/* eslint-disable */
// @ts-nocheck

import { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import {
  ArrowUturnLeftIcon,
  PlusIcon,
  TrashIcon,
} from '@heroicons/react/24/outline'

import useServer from '@/api/useServerMain'
import useServerProduct from '@/api/useServerProducts'
import defaultImage from '@/assets/image-default.jpg'
import CustomRadio, { CustomRadioData } from '@/components/forms/CustomRadio'
import ProductTypeBadge from '@/components/misc/badges/ProductTypeBadge'
import Button from '@/components/misc/Button'
import EmptyList from '@/components/misc/EmptyList'
import Modal from '@/components/misc/GenericModal'
import GenericTable, {
  DataTableInterface,
} from '@/components/misc/GenericTable'
import { BtnActions } from '@/components/misc/MultipleActBtn'
import SearchComponent from '@/components/misc/SearchComponent'
import SpinnerLoading from '@/components/misc/SpinnerLoading'
import {
  Manufacturations,
  ProductInterface,
} from '@/interfaces/ServerInterfaces'
import { translateMeasure } from '@/utils/translate'

import { DetailProductContext } from '../DetailProductContainer'

const currency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const Descomposition = () => {
  const { denyRoles } = useServer()

  const { product, manageManufacturer } = useContext(DetailProductContext)
  const [dataTable, setDataTable] = useState<
    Partial<Manufacturations & { status: 'add' | 'del' }>[]
  >([])
  const [addModal, setAddModal] = useState(false)
  useEffect(() => {
    product?.listManufacturations && setDataTable(product.listManufacturations)
  }, [product])

  const addSuplies = (data: ProductInterface) => {
    setDataTable([
      ...dataTable,
      {
        id: data.id,
        name: data.name,
        measure: data.measure,
        status: 'add',
        type: data.type,
      },
    ])
    setAddModal(false)
  }

  const deleteSupply = (idx: number) => {
    const nextData = [...dataTable]
    nextData.splice(idx, 1, { ...nextData[idx], status: 'del' })
    setDataTable(nextData)
  }

  const undelete = (idx: number) => {
    const nextData = [...dataTable]
    nextData.splice(idx, 1, { ...nextData[idx], status: undefined })
    setDataTable(nextData)
  }

  const fetchSupplyUpdate = () => {
    const dataToSend = dataTable.filter((item) => item.status !== 'del')
    const data = dataToSend.map((item) => item.id)
    manageManufacturer && manageManufacturer(product?.id, data)
  }

  //Data for table ---------------------------------------------------------------------------------------
  const tableData: DataTableInterface[] = []
  dataTable.map((item, idx) =>
    tableData.push({
      rowId: item.id,
      boldRow: item.status === 'add',
      deletedRow: item.status === 'del',
      payload: {
        Producto: item.name,
        Tipo: <ProductTypeBadge type={item?.type!} />,
        U_Medida: translateMeasure(item.measure),
        '': (
          <div className="flex gap-1">
            {item.status !== 'del' ? (
              <>
                <Button
                  action={() => deleteSupply(idx)}
                  color="red-500"
                  icon={<TrashIcon className="h-4 text-red-500" />}
                  outline
                />
              </>
            ) : (
              <Button
                action={() => undelete(idx)}
                color="gray-500"
                icon={<ArrowUturnLeftIcon className="h-4 text-gray-500" />}
                outline
              />
            )}
          </div>
        ),
      },
    })
  )

  const tableTitles = ['Producto', 'Tipo', 'U_Medida', '']

  const actions: BtnActions[] = []

  if (denyRoles(['AUDITOR'])) {
    actions.push({
      title: 'Nuevo producto',
      icon: <PlusIcon className="h-6" />,
      action: () => setAddModal(true),
    })
  }

  //----------------------------------------------------------------------------------------------------
  return (
    <div className="h-[36rem]">
      <div className="h-[500px] rounded-md border border-slate-300 p-3 pr-5 scrollbar-thin scrollbar-thumb-gray-100">
        <GenericTable
          actions={actions}
          tableData={tableData}
          tableTitles={tableTitles}
        />
      </div>
      <div className="flex justify-end py-5">
        {denyRoles(['AUDITOR']) && (
          <Button
            action={fetchSupplyUpdate}
            color="slate-600"
            name="Actualizar"
          />
        )}
      </div>
      {addModal && (
        <Modal close={setAddModal} size="m" state={addModal}>
          <NewElement addElement={addSuplies} />
        </Modal>
      )}
    </div>
  )
}

//New Product Modal --------------------------------------------
interface NewElement {
  addElement: Function
}

const NewElement = ({ addElement }: NewElement) => {
  const { control, handleSubmit, getValues, setError, watch, clearErrors } =
    useForm()
  const { getAllProducts, allProducts, outLoading } = useServerProduct()
  const [search, setSearch] = useState<string | null>(null)

  const onSubmit: SubmitHandler<Record<string, string | number | boolean>> = (
    data
  ) => {
    const supplyProductId = getValues('supplyProductId')
    if (!supplyProductId) {
      toast.error('Busque y seleccione un producto', { autoClose: 5000 })
    } else {
      addElement({
        ...allProducts.find((prod) => prod.id === supplyProductId),
        quantity: data.quantity,
      })
    }
  }

  //Data for list product -----------------------------------------------------------------------
  useEffect(() => {
    search &&
      getAllProducts({
        type: 'RAW,MANUFACTURED,STOCK,WASTE',
        search,
        all_data: true,
      })
  }, [search])

  const data: CustomRadioData[] = []
  search &&
    allProducts.map((product) =>
      data.push({
        value: product.id,
        img: product.images[0]?.src ?? defaultImage,
        name: product.name,
        elements: {
          type: <ProductTypeBadge type={product.type} />,
          measure: translateMeasure(product.measure),
          cost: currency.format(product.averageCost),
        },
      })
    )
  //---------------------------------------------------------------------------------------------

  return (
    <>
      <SearchComponent findAction={setSearch} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 h-[36rem] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-100">
          {outLoading ? (
            <SpinnerLoading text="Buscando producto" />
          ) : data.length === 0 && !search ? (
            <EmptyList
              subTitle="Inserte un criterio de búsqueda"
              title="Buscar Producto"
            />
          ) : data.length === 0 && search ? (
            <EmptyList
              subTitle="Inserte otro criterio de búsqueda"
              title="Producto no encontrado"
            />
          ) : (
            <CustomRadio
              action={() => clearErrors()}
              control={control}
              data={data}
              name="supplyProductId"
            />
          )}
        </div>
        <div className="flex justify-end py-4">
          <Button color="slate-600" name="Agregar" type="submit" />
        </div>
      </form>
    </>
  )
}

export default Descomposition
